export function formatValue(value, fallback = 'Not available') {
  const normalized = String(value ?? '').trim();
  return normalized || fallback;
}

export function formatEnumLabel(value, emptyLabel = 'Not set') {
  const normalized = String(value ?? '').trim();
  if (!normalized) {
    return emptyLabel;
  }

  return normalized
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function safeDate(value) {
  const normalized = String(value ?? '').trim();

  if (!normalized) {
    return null;
  }

  const resolved = new Date(normalized);
  return Number.isNaN(resolved.getTime()) ? null : resolved;
}

export function formatDate(value, fallback = 'No due date') {
  const normalized = String(value ?? '').trim();
  if (!normalized) {
    return fallback;
  }

  const [year, month, day] = normalized.slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) {
    return fallback;
  }

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(year, month - 1, day));
}

export function formatDateTime(value, fallback = 'Not recorded') {
  const resolved = safeDate(value);

  if (!resolved) {
    return fallback;
  }

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(resolved);
}
